import moment from 'moment-timezone';
import { Product, ProductSummary } from 'models/product';

export const isStillNotOnSale = (product: Product | ProductSummary | undefined) => {
  const timezone = moment.tz.guess();
  const startDateTime = moment(
    product?.agent_guest_booking_period_settings?.booking_start_date_time_utc
  ).tz(product?.start_timezone ?? timezone);

  return (
    product?.agent_guest_booking_period_settings?.should_use_booking_start_date_time &&
    startDateTime.isAfter(moment())
  );
};
